import { render } from "./WirepasAssetsView.vue?vue&type=template&id=f1c8df64&scoped=true&ts=true"
import script from "./WirepasAssetsView.vue?vue&type=script&lang=ts"
export * from "./WirepasAssetsView.vue?vue&type=script&lang=ts"

import "./WirepasAssetsView.vue?vue&type=style&index=0&id=f1c8df64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c8df64"]])

export default __exports__